// extracted by mini-css-extract-plugin
export default {"root":"_34VNZ","button":"_3sF1c","is-active":"_2OY7Y","isActive":"_2OY7Y"};